import styled from 'styled-components'
import PreloadBar from '../../components/PreloadBar'
import { media } from '../../theme'

const StyledPreloadBar = styled(PreloadBar)`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;

  ${media.greaterThan('medium')`
    width: 25%;
  `};
`

export default StyledPreloadBar



// WEBPACK FOOTER //
// ./src/pages/bedroom/_StyledPreloadBar.js